import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngrx/store';
import {getRouterState} from 'src/app/store/router';

@Component({
    selector: 'smart-page-breadcrumb',
    templateUrl: './page-breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./page-breadcrumb.component.css']
})
export class PageBreadcrumbComponent {

    date = Date.now();

    vm$ = this.store.select(getRouterState);
    iconBreadcrumb = new Map<string, string>();

    constructor(private store: Store<any>) {
        this.iconBreadcrumb.set('Modules', 'fas fa-th');
    }
}

